import * as types from "../actions/actionTypes";
//
import {
  addSections,
  hidePayrollSection,
  hideTimesheetsSection,
  hideRAOnboardingSection,
  hideBookingsSection,
  hidePayslipsSection,
  hideHolidaySection,
  hideGreatBearSection,
  addPercentage,
  handleCvStatus,
  completeRAOnboardingSection,
  hideAddressSection,
  hideMobileTelephoneSection,
  hideBirthDateSection,
  hideRoyalMailOnboardingSection,
  hideDnataOnboardingSection,
  hidePecanSection,
  hidePusterlaSection,
  hideKingspanSection,
  hideRegattaSection,
  completePecanOnboardingSection,
  completePusterlaOnboardingSection,
  completeDnataOnboardingSection,
  completeSwissportOnboardingSection,
  completeNHSReferencingFormSection,
  hideSwissportOnboardingSection,
  hideNHSReferencesFormSection,
  hideProfileImageSection,
  completeRoyalMailOnboardingSection,
  hideDrivingOnboardingSection,
  completeDrivingOnboardingSection,
  completeGreatBearOnboardingSection,
  completeKingspanOnboardingSection,
  completeGLAASection,
  hideGLAASection,
  completeRegattaOnboardingSection,
  hideGateOnboardingSection,
  completeGateOnboardingSection,
  completeABMOnboardingSection,
  hideABMOnboardingSection,
  hideCarltonForestOnboardingSection,
  completeCarltonForestOnboardingSection,
  hideCPIOnboardingSection,
  completeCPIOnboardingSection,
  hideThanetCouncilOnboardingSection,
  completeThanetCouncilOnboardingSection,
  hideUmbrellaDeclarationSection,
  completeUmbrellaDeclarationFormSection,
  hideMolecularOnboardingSection,
  hideWoodlandOnboardingSection,
  completeMolecularOnboardingSection,
  completeWoodlandOnboardingSection,
  hideCompleatFoodOnboardingSection,
  completeCompleatFoodOnboardingSection,
  hideGrowUpFarmsOnboardingSection,
  completeGrowUpFarmsOnboardingSection,
  hideDavinFoodsOnboardingSection,
  completeDavinFoodsOnboardingSection,
} from "../../helpers/sectionProgress";
import { pipe, removeKeys, mergeShallow as merge, isNil } from "../../helpers";
import { getByPath } from "../../helpers/utils";

export const initialState = {
  addressList: {},
  postcodeError: null,
  app: null,
  user: null,
  auth: {
    isCheckingAuthState: false,
    authStateChecked: false,
    isAuthenticating: false,
    userFlow: null,
    authenticationError: null,
    shouldForceTokenRefresh: false,
    shouldRedirectToProfile: true,
    isLoading: false,
    shouldOnboard: true,
  },
  loading: false,
  isCvLoading: false,
  isOpenModal: false,
  onboardState: {
    basic: false,
    address: false,
    cv: false,
    workType: false,
    personalDeclaration: false,
  },
  error: null,
  oneClickApply: {
    isLoading: false,
  },
  timesheets: {
    nonAttendanceCodes: {},
    isLoading: false,
  },
  payslips: {
    isLoading: false,
  },
  latestJobs: {
    isLoading: false,
  },
  bookings: {
    isLoading: false,
  },
  greatBearReading: {
    isLoading: false,
  },
  kingspanReading: {
    isLoading: false,
  },
  regattaReading: {
    isLoading: false,
  },
  regattaAssessment: {
    isLoading: false,
  },
  pusterlaReading: {
    isLoading: false,
  },
  carltonForest: {
    isReadingLoading: false,
    isInductionFormLoading: false,
    inductionFormStatus: "todo",
    isInductionFormItemLoading: false,
    ssowFormName: "",
    isSSOWLoading: false,
  },
  thanetCouncilReading: {
    isReadingLoading: false,
  },

  cpiReading: {
    isReadingLoading: false,
  },

  compleatFood: {
    isReadingLoading: false,
    formLoading: "",
  },
  kingspanSOP: {
    formName: "",
  },
  kingspanAssessment: {
    isLoading: false,
  },
  thanetCouncilRiskAssesment: {
    formName: "",
  },
  pecanAssessment: {
    isLoading: false,
  },
  pecanReading: {
    isLoading: false,
  },
  molecularReading: {
    isLoading: false,
  },
  molecularAssessment: {
    isLoading: false,
  },
  dnataTest: {
    isLoading: false,
  },
  dnata: {
    formLoading: "",
  },
  swissport: {
    isLoading: "",
  },
  courses: {
    isLoading: null,
    enrolled: [],
  },
  growUpFarmsReading: {
    isLoading: false,
  },
  growUpFarmsFoodQuestionnaire: {
    isLoading: false,
  },
  ipnOnboarding: {
    isIpnLoading: false,
  },
  errors: [],
  umbracoContent: {},
  isUserLoading: false,
  isPendingConfirmation: false,
  workHistory: [],
  showErrorModal: false,
  errorMessage: undefined,
  modalRootRef: undefined,
  reflexAllenForms: [],
  isRetryingRegister: false,
  rtwVerificationCall: {
    isLoading: false,
  },
  holidayData: {
    isLoading: true,
  },
  holidayHistoryData: [],
  isDiskAssessmentTestLoading: false,
  holidayRequest: {
    holidayRequestFormLoading: false,
    holidayRequestFormSubmitted: null,
  },
  davinFoods: {
    isReadingLoading: false,
    quizLoading: "",
    quizShowResults: "",
  },
};

const setSectionProgress = pipe(
  addSections,
  hidePayrollSection,
  hideTimesheetsSection,
  hideRAOnboardingSection,
  hideBookingsSection,
  hidePayslipsSection,
  hideHolidaySection,
  handleCvStatus,
  completeRAOnboardingSection,
  hideAddressSection,
  hideMobileTelephoneSection,
  hideBirthDateSection,
  hideGreatBearSection,
  hideRoyalMailOnboardingSection,
  hideDnataOnboardingSection,
  hidePecanSection,
  hidePusterlaSection,
  hideKingspanSection,
  hideCarltonForestOnboardingSection,
  hideRegattaSection,
  hideGLAASection,
  completeGLAASection,
  hideDrivingOnboardingSection,
  hideSwissportOnboardingSection,
  hideNHSReferencesFormSection,
  hideGateOnboardingSection,
  hideABMOnboardingSection,
  hideThanetCouncilOnboardingSection,
  hideUmbrellaDeclarationSection,
  hideCPIOnboardingSection,
  hideMolecularOnboardingSection,
  hideWoodlandOnboardingSection,
  hideCompleatFoodOnboardingSection,
  hideGrowUpFarmsOnboardingSection,
  hideDavinFoodsOnboardingSection,
  completeDavinFoodsOnboardingSection,
  completeGrowUpFarmsOnboardingSection,
  completeCompleatFoodOnboardingSection,
  completeMolecularOnboardingSection,
  hideCompleatFoodOnboardingSection,
  hideMolecularOnboardingSection,
  hideWoodlandOnboardingSection,
  completeWoodlandOnboardingSection,
  completeDnataOnboardingSection,
  completeSwissportOnboardingSection,
  completeNHSReferencingFormSection,
  completeGateOnboardingSection,
  completeABMOnboardingSection,
  completePecanOnboardingSection,
  completePusterlaOnboardingSection,
  completeRoyalMailOnboardingSection,
  completeThanetCouncilOnboardingSection,
  completeGreatBearOnboardingSection,
  completeDrivingOnboardingSection,
  completeKingspanOnboardingSection,
  completeCarltonForestOnboardingSection,
  completeRegattaOnboardingSection,
  completeUmbrellaDeclarationFormSection,
  completeCPIOnboardingSection,
  hideProfileImageSection,
  addPercentage
);

const setWorkHours = (appState) => ({
  ...appState,
  workHours: !isNil(appState.partTimeHours) || !isNil(appState.fullTimeHours),
});

const setWorkType = (appState) => ({
  ...appState,
  workType:
    !isNil(appState.permWorkSeeking) || !isNil(appState.tempWorkSeeking),
});

const setProfileImage = (appState) => {
  if (!appState.profileImageData) {
    return appState;
  }
  const newAppState = {
    ...appState,
    profileImage: merge(appState.profileImage || {}, {
      previewContent: appState.profileImageData,
    }),
  };
  return removeKeys(newAppState, "profileImageData");
};

const setRoyalMailId = (appState) => {
  if (!appState.royalMailId) {
    return appState;
  }
  const newAppState = {
    ...appState,
    royalMailOnboarding: merge(appState.royalMailOnboarding || {}, {
      idImage: merge(
        (appState.royalMailOnboarding &&
          appState.royalMailOnboarding.idImage) ||
          {},
        {
          fileContent: appState.royalMailId,
        }
      ),
    }),
  };
  return removeKeys(newAppState, "royalMailId");
};

const setRoyalMailIdCard = (appState) => {
  if (!appState.royalMailIdCard) {
    return appState;
  }
  const newAppState = {
    ...appState,
    royalMailOnboarding: merge(appState.royalMailOnboarding || {}, {
      idCardImage: merge(
        (appState.royalMailOnboarding &&
          appState.royalMailOnboarding.idCardImage) ||
          {},
        {
          fileContent: appState.royalMailIdCard,
        }
      ),
    }),
  };
  return removeKeys(newAppState, "royalMailIdCard");
};

const setDnataDeclaration = (appState) => {
  if (!appState.dnataDeclaration) {
    return appState;
  }
  const newAppState = {
    ...appState,
    dnataOnboarding: merge(appState.dnataOnboarding || {}, {
      dnataDeclaration: merge(
        (appState.dnataOnboarding &&
          appState.dnataOnboarding.dnataDeclaration) ||
          {},
        {
          fileContent: appState.dnataDeclaration,
        }
      ),
    }),
  };
  return removeKeys(newAppState, "dnataDeclaration");
};

const setABMDeclaration = (appState) => {
  if (!appState.abmDeclaration) {
    return appState;
  }
  const newAppState = {
    ...appState,
    abmOnboarding: merge(appState.abmOnboarding || {}, {
      abmDeclaration: merge(
        (appState.abmOnboarding && appState.abmOnboarding.abmDeclaration) || {},
        {
          fileContent: appState.abmDeclaration,
        }
      ),
    }),
  };
  return removeKeys(newAppState, "abmDeclaration");
};

// /**
//  * Handle file upload for clients. An example can be found in Regatta where a medication image is requirred.
//  * @param {*} clientState e.g. appData.regattaOnboarding
//  * @param {*} appState e.g appData
//  * @param {*} propertyName e.g medicalPhoto
//  * @returns
//  */
const setRegattaMedical = (appState) => {
  if (!appState.regattaMedicalPhoto) {
    return appState;
  }
  const newAppState = {
    ...appState,
    regattaOnboarding: merge(appState.regattaOnboarding || {}, {
      regattaMedicalPhoto: merge(
        (appState.regattaOnboarding &&
          appState.regattaOnboarding.regattaMedicalPhoto) ||
          {},
        {
          fileContent: appState.regattaMedicalPhoto,
        }
      ),
    }),
  };
  return removeKeys(newAppState, "regattaMedicalPhoto");
};

const setABMDeclaration2 = (appState) => {
  if (!appState.abmDeclaration2) {
    return appState;
  }
  const newAppState = {
    ...appState,
    abmOnboarding: merge(appState.abmOnboarding || {}, {
      abmDeclaration2: merge(
        (appState.abmOnboarding && appState.abmOnboarding.abmDeclaration2) ||
          {},
        {
          fileContent: appState.abmDeclaration2,
        }
      ),
    }),
  };
  return removeKeys(newAppState, "abmDeclaration2");
};

const transformAppState = pipe(
  setWorkType,
  setWorkHours,
  setProfileImage,
  setRoyalMailId,
  setRoyalMailIdCard,
  setSectionProgress,
  setDnataDeclaration,
  setRegattaMedical,
  setABMDeclaration,
  setABMDeclaration2
);

const matchTypeCode = (documentType, side) => {
  const typeCodes = {
    passport: { front: "JPPT" },
    expiredPassport: { front: "JPPE" },
    visaPassport: { front: "JPVI", back: "JPVB" },
    birthCertificate: { front: "JBIR", back: "JPNI" },
    shareCode: { front: "NSHA" },
    other: { front: "JPID", back: "JPPB" },
  };

  return typeCodes[documentType][side];
};

const actionHandlers = {
  // Authentication reducers
  [types.USER_SET_IS_LOADING]: (state, { isLoading, userFlow }) =>
    merge(state, {
      isUserLoading: isLoading,
      userFlow,
    }),
  [types.AUTH_SHOULD_ONBOARD]: (state, shouldOnboard) =>
    merge(state, {
      auth: {
        ...state.auth,
        shouldOnboard,
      },
    }),
  // Onboard state reducers
  [types.ONBOARD_LOADED_STATE]: (state, onboardState) =>
    merge(state, { onboardState }),
  [types.ONBOARD_UPDATE_STATE_ITEM]: (state, stateItem, value) =>
    merge(state, { onboardState: { [stateItem]: value } }),
  // Loading state reducers
  [types.SET_LOADING_STATE]: (state, loading) => merge(state, { loading }),
  [types.SET_CV_IS_LOADING]: (state, isCvLoading) =>
    merge(state, {
      isCvLoading,
      app: { ...state.app, cv: { ...state.app.cv, isCvLoading } || {} },
    }),
  // Open modal reducer
  [types.SET_MODAL_STATE]: (state, isOpenModal) =>
    merge(state, { isOpenModal }),
  // User data reducers
  [types.STORE_USER_DATA_IN_APP]: (state, userData) =>
    merge(state, { app: transformAppState({ ...state.app, ...userData }) }),
  [types.REFRESH_SECTIONS]: (state) =>
    merge(state, { app: transformAppState({ ...state.app }) }),
  [types.STORE_ADDRESS_LIST_IN_APP]: (state, addressList) =>
    merge(state, { addressList }),
  [types.STORE_WORK_HISTORY_IN_APP]: (state, workHistoryData) =>
    merge(state, {
      app: {
        workHistory: workHistoryData,
      },
    }),
  [types.BOOKING_SET_DATA]: (state, bookings) =>
    merge(state, { bookings: { ...state.bookings, bookings } }),
  [types.BOOKING_SET_IS_LOADING]: (state, isLoading) =>
    merge(state, { bookings: { ...state.bookings, isLoading } }),
  [types.TIMESHEETS_SET_IS_LOADING]: (state, isLoading) =>
    merge(state, { timesheets: { ...state.timesheets, isLoading } }),
  [types.TIMESHEETS_SET_DATA]: (state, timesheets) =>
    merge(state, { timesheets: { ...state.timesheets, timesheets } }),
  [types.TIMESHEET_IS_UPDATING]: (
    state,
    { timesheet, shouldSendNotification }
  ) => {
    const timesheets = state.timesheets.timesheets.map((t) =>
      t.timesheetRef === timesheet.timesheetRef
        ? { ...t, isUpdating: true, submitted: shouldSendNotification }
        : t
    );
    return merge(state, { timesheets: { ...state.timesheets, timesheets } });
  },
  [types.TIMESHEET_UPDATE_SUCCESS]: (state, timesheet) => {
    const timesheets = state.timesheets.timesheets.map((t) =>
      t.timesheetRef === timesheet.timesheetRef
        ? {
            ...timesheet,
            calculatedStatusCode:
              t.calculatedStatusCode === "Z05" ? "Z10" : t.calculatedStatusCode,
            isUpdating: false,
            hasUpdated: true,
          }
        : t
    );
    return merge(state, { timesheets: { ...state.timesheets, timesheets } });
  },
  [types.TIMESHEET_UPDATE_FAILED]: (state, timesheet) => {
    const timesheets = state.timesheets.timesheets.map((t) =>
      t.timesheetRef === timesheet.timesheetRef
        ? { ...t, isUpdating: false, errorUpdating: true }
        : t
    );
    return merge(state, { timesheets: { ...state.timesheets, timesheets } });
  },
  [types.NON_ATTENDANCE_LOOKUP_DATA]: (state, nonAttendanceLookups) =>
    merge(state, {
      timesheets: {
        ...state.timesheets,
        nonAttendanceCodes: nonAttendanceLookups,
      },
    }),
  // eslint-disable-next-line
  [types.PAYSLIPS_SET_DATA]: (
    state,
    // eslint-disable-next-line
    { payslips, hasP45, hasP60_2022, hasP60_2023, hasP60_2024, hasP60_2025 }
  ) =>
    merge(state, {
      payslips: {
        ...state.payslips,
        payslips,
        hasP45,
        hasP60_2022,
        hasP60_2023,
        hasP60_2024,
        hasP60_2025,
      },
    }),
  [types.PAYSLIPS_SET_IS_LOADING]: (state, isLoading) =>
    merge(state, { payslips: { ...state.payslips, isLoading } }),

  [types.HOLIDAY_SET_DATA]: (state, { holidayData }) => {
    if (holidayData && holidayData.length === 0) {
      return merge(state, {
        holidayData: { isLoading: false, holidayData: [] },
      });
    }

    return merge(state, {
      holidayData: { ...state.holidayData, ...holidayData },
    });
  },

  [types.HOLIDAY_HISTORY_SET_DATA]: (state, { holidayHistoryData }) =>
    merge(state, { holidayHistoryData: [...holidayHistoryData] }),

  [types.HOLIDAY_SET_IS_LOADING]: (state, isLoading) =>
    merge(state, { holidayData: { ...state.holidayData, isLoading } }),

  [types.LATEST_JOBS_SET_DATA]: (state, { latestJobs }) =>
    merge(state, { latestJobs: { ...state.latestJobs, latestJobs } }),

  [types.LATEST_JOBS_SET_IS_LOADING]: (state, isLoading) =>
    merge(state, { latestJobs: { ...state.latestJobs, isLoading } }),

  [types.ADD_SERVER_ERROR]: (state, error) =>
    merge(state, { errors: [...state.errors, error] }),
  [types.CLEAR_SERVER_ERRORS]: (state, source) =>
    merge(state, {
      errors: state.errors.filter((err) => err.source !== source),
    }),
  [types.APPLY_API_LOADING]: (state, isLoading) =>
    merge(state, { oneClickApply: { ...state.oneClickApply, isLoading } }),
  [types.APPLY_API_SUCCESS]: (state) =>
    merge(state, { oneClickApply: { ...state.oneClickApply, success: true } }),
  [types.APPLY_API_ERROR]: (state, error) =>
    merge(state, { oneClickApply: { ...state.oneClickApply, error } }),
  [types.STORE_UMBRACO_CONTENT]: (state, content) =>
    merge(state, { umbracoContent: content }),
  [types.POSTCODE_ERROR_SET]: (state, postcodeError) =>
    merge(state, { postcodeError }),
  [types.POSTCODE_ERROR_CLEAR]: (state) =>
    merge(state, { postcodeError: null }),
  [types.SET_ERROR]: (state, error) => merge(state, { error }),
  [types.HTTP_404_ERROR]: (state, action) => {
    action.props.history.push("/404");
    return { ...state };
  },
  [types.HTTP_500_ERROR]: (state, action) => {
    action.props.history.push("/500");
    return { ...state };
  },
  [types.HTTP_OTHER_ERROR]: (state, action) => {
    if (!action) return { ...state };

    const error =
      getByPath("error.message", action) || "An internal error has occured";

    const errors = [...state.errors];
    errors.push(error);
    return merge(state, { showErrorModal: true, errorMessage: error, errors });
  },
  [types.DISMISS_ERROR_MODAL]: (state) =>
    merge(state, { showErrorModal: false, errorMessage: undefined }),
  [types.RTW_INITIATE_CHECK]: (state, action) => {
    const toBase64 = (content) => Buffer.from(content).toString("base64");

    const rightToWorkFiles = [];

    if (action.selfieFile) {
      rightToWorkFiles.push({
        TypeCode: "JPSE",
        DisplayName: "Selfie",
        FileContent: action.selfieFile,
      });
    }

    if (action.idType === "shareCode") {
      const studentFiles = {
        courseCompleted: {
          front: {
            DisplayName: "Course Completion Confirmation",
            FileContent: action.frontOfIdFile,
            TypeCode: "JCCC",
          },
          back: {
            DisplayName: "University enrolment letter",
            FileContent: action.backOfIdFile,
            TypeCode: "JUNI",
          },
        },
        courseEnrolled: {
          front: {
            DisplayName: "University enrolment letter",
            FileContent: action.frontOfIdFile,
            TypeCode: "JUNI",
          },
          back: {
            DisplayName: "Term Dates",
            FileContent: action.backOfIdFile,
            TypeCode: "JUTD",
          },
        },
      };

      const courseState = action.courseCompleted
        ? "courseCompleted"
        : "courseEnrolled";

      if (action.frontOfIdFile) {
        rightToWorkFiles.push(studentFiles[courseState].front);
      }
      if (action.backOfIdFile) {
        rightToWorkFiles.push(studentFiles[courseState].back);
      }
      if (action.shareCodeFile) {
        rightToWorkFiles.push({
          DisplayName: "Sharecode",
          FileContent: toBase64(action.shareCodeFile),
          TypeCode: matchTypeCode(action.idType, "front"),
        });
      }
    } else {
      rightToWorkFiles.push({
        DisplayName: "Front",
        FileContent: action.frontOfIdFile,
        TypeCode: matchTypeCode(action.idType, "front"),
      });
      if (action.backOfIdFile) {
        rightToWorkFiles.push({
          DisplayName: "Back",
          FileContent: action.backOfIdFile,
          TypeCode: matchTypeCode(action.idType, "back"),
        });
      }
      if (action.niProofFile) {
        rightToWorkFiles.push({
          DisplayName: "NiBack",
          FileContent: action.niProofFile,
          TypeCode: "JPNI",
        });
      }
    }

    return merge(state, {
      loading: true,
      app: merge(state.app, { rightToWorkFiles }),
    });
  },
  [types.RTW_CHECK_SUCCESS]: (state) =>
    merge(state, {
      loading: false,
      app: transformAppState({ ...state.app, rightToWorkChecked: true }),
    }),
  [types.RTW_CHECK_ERROR]: (state) =>
    merge(state, {
      loading: false,
      app: merge(state.app, { rightToWorkChecked: true }),
    }),
  [types.DOCUMENTATION_INITIATE_UPLOAD]: (state, action) => {
    const documentationFiles = [
      ...(state.app.documentationFiles ? state.app.documentationFiles : []),
      {
        TypeCode: action.fileTypeCode,
        DisplayName: action.displayName,
        FileContent: action.documentFile,
      },
    ];
    return merge(state, {
      loading: true,
      app: merge(state.app, { documentationFiles }),
    });
  },
  [types.DOCUMENTATION_SUCCESS]: (state) =>
    merge(state, {
      loading: false,
    }),
  [types.DOCUMENTATION_ERROR]: (state) =>
    merge(state, {
      loading: false,
    }),
  [types.MARK_DOCUMENT_READ]: (state, documentFilename) => {
    const currentDocs =
      (state.app.reflexAllen && state.app.reflexAllen.readDocuments) || [];
    return merge(state, {
      app: merge(state.app, {
        reflexAllen: {
          ...state.app.reflexAllen,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.MARK_DOCUMENT_READ_GB]: (state, documentFilename) => {
    const greatBearState = state.app.greatBear || {};
    const currentDocs =
      (state.app.greatBear && state.app.greatBear.readDocuments) || [];

    return merge(state, {
      app: merge(state.app, {
        greatBear: {
          ...greatBearState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.MARK_DOCUMENT_READ_WOODLAND]: (state, documentFilename) => {
    const woodland = state.app.woodlandGroupOnboarding || {};
    const currentDocs =
      (state.app.woodlandGroupOnboarding &&
        state.app.woodlandGroupOnboarding.readDocuments) ||
      [];

    return merge(state, {
      app: merge(state.app, {
        woodlandGroupOnboarding: {
          ...woodland,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.MARK_DOCUMENT_READ_REGATTA]: (state, documentFilename) => {
    const regattaOnboardingState = state.app.regattaOnboarding || {};
    const currentDocs =
      (state.app.regattaOnboarding &&
        state.app.regattaOnboarding.readDocuments) ||
      [];

    return merge(state, {
      app: merge(state.app, {
        regattaOnboarding: {
          ...regattaOnboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.POST_USER_FEEDBACK_CLOSE]: (state) => {
    return merge(state, {
      app: merge(state.app, {
        surveyData: {
          showSurvey: false,
        },
      }),
    });
  },
  [types.POST_USER_FEEDBACK_DISMISSAL]: (state, payload) => {
    return merge(state, {
      app: merge(state.app, {
        surveyData: {
          showSurvey: false,
        },
      }),
    });
  },
  [types.MARK_DOCUMENT_READ_PUSTERLA]: (state, documentFilename) => {
    const pusterlaOnboardingState = state.app.pusterlaOnboarding || {};
    const currentDocs =
      (state.app.pusterlaOnboarding &&
        state.app.pusterlaOnboarding.readDocuments) ||
      [];

    return merge(state, {
      app: merge(state.app, {
        pusterlaOnboarding: {
          ...pusterlaOnboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.MARK_DOCUMENT_READ_KINGSPAN]: (state, documentFilename) => {
    const kingspanOnboardingState = state.app.kingspanOnboarding || {};
    const currentDocs =
      (state.app.kingspanOnboarding &&
        state.app.kingspanOnboarding.readDocuments) ||
      [];

    return merge(state, {
      app: merge(state.app, {
        kingspanOnboarding: {
          ...kingspanOnboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.MARK_DOCUMENT_READ_PECAN]: (state, documentFilename) => {
    const pecanOnboardingState = state.app.pecanOnboarding || {};
    const currentDocs =
      (state.app.pecanOnboarding && state.app.pecanOnboarding.readDocuments) ||
      [];

    return merge(state, {
      app: merge(state.app, {
        pecanOnboarding: {
          ...pecanOnboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.POST_REFLEX_ALLEN_FORM]: (state, submittedForm) => {
    const currentForms =
      (state.app.reflexAllen && state.app.reflexAllen.onlineForms) || [];
    return merge(state, {
      app: merge(state.app, {
        reflexAllen: {
          ...state.app.reflexAllen,
          onlineForms: [...currentForms, submittedForm.online_form],
        },
      }),
    });
  },
  [types.SET_REFLEX_ALLEN_FORMS]: (state, { pdfString, formCode }) => {
    return merge(state, {
      reflexAllenForms: [
        ...state.reflexAllenForms.filter(
          (formElem) => formElem.formCode !== formCode
        ),
        { pdfString, formCode, isDownloading: false },
      ],
    });
  },

  [types.GREAT_BEAR_READING_SET_IS_LOADING]: (state, isLoading) =>
    merge(state, {
      greatBearReading: { ...state.greatBearReading, isLoading },
    }),

  [types.SET_PUSTERLA_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      pusterlaReading: { ...state.pusterlaReading, isLoading },
    }),

  [types.SET_REGATTA_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      regattaReading: { ...state.regattaReading, isLoading },
    }),

  [types.SET_KINGSPAN_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      kingspanReading: { ...state.kingspanReading, isLoading },
    }),

  [types.SET_THANET_COUNCIL_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      thanetCouncilReading: {
        ...state.thanetCouncilReading,
        isReadingLoading: isLoading,
      },
    }),

  [types.MARK_DOCUMENT_READ_THANET_COUNCIL]: (state, documentFilename) => {
    const onboardingState = state.app.thanetCouncilOnboarding || {};
    const currentDocs =
      (state.app.thanetCouncilOnboarding &&
        state.app.thanetCouncilOnboarding.readDocuments) ||
      [];

    return merge(state, {
      app: merge(state.app, {
        thanetCouncilOnboarding: {
          ...onboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.POST_RISK_ASSESSMENT_THANET_COUNCIL]: (
    state,
    { formName, formContent }
  ) => {
    const previousRiskAssessments =
      state.app.thanetCouncilOnboarding[formName] || [];
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        thanetCouncilOnboarding: {
          ...state.app.thanetCouncilOnboarding,
          [formName]: {
            ...previousRiskAssessments,
            ...formContent,
          },
        },
      },
    });
  },

  [types.POST_THANET_COUNCIL_FORMS]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        thanetCouncilOnboarding: {
          ...state.app.thanetCouncilOnboarding,
          [formName]: formContent,
        },
      },
    });
  },

  [types.SUBMIT_THANET_COUNCIL_FORMS]: (state, { typeCode }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        thanetCouncilOnboarding: {
          ...state.app.thanetCouncilOnboarding,
          [typeCode]: true,
        },
      },
    });
  },

  [types.MARK_DOCUMENT_READ_CPI]: (state, documentFilename) => {
    const cpiOnboardingState = state.app.cpiOnboarding || {};
    const currentDocs =
      (state.app.cpiOnboarding && state.app.cpiOnboarding.readDocuments) || [];

    return merge(state, {
      app: merge(state.app, {
        cpiOnboarding: {
          ...cpiOnboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },

  [types.SET_CPI_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      cpiReading: { ...state.CPI, isReadingLoading: isLoading },
    }),

  [types.POST_CARLTON_FOREST_FORMS]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        carltonForestOnboarding: {
          ...state.app.carltonForestOnboarding,
          [formName]: formContent,
        },
      },
    });
  },
  [types.SUBMIT_CARLTON_FOREST_FORMS]: (state, { typeCode }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        carltonForestOnboarding: {
          ...state.app.carltonForestOnboarding,
          YCFG: true,
        },
      },
    });
  },
  [types.MARK_DOCUMENT_READ_CARLTON_FOREST]: (state, documentFilename) => {
    const carltonForestOnboardingState =
      state.app.carltonForestOnboarding || {};
    const currentDocs =
      (state.app.carltonForestOnboarding &&
        state.app.carltonForestOnboarding.readDocuments) ||
      [];

    return merge(state, {
      app: merge(state.app, {
        carltonForestOnboarding: {
          ...carltonForestOnboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },

  [types.SET_CARLTON_FOREST_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      carltonForest: { ...state.carltonForest, isReadingLoading: isLoading },
    }),

  [types.SET_IPN_LOADING]: (state, isLoading) => {
    return merge(state, {
      ipnOnboarding: { ...state.ipnOnboarding, isIpnLoading: isLoading },
    });
  },

  [types.SET_INDUCTION_FORM_CARLTON_FOREST_LOADING]: (state, isLoading) =>
    merge(state, {
      carltonForest: {
        ...state.carltonForest,
        isInductionFormLoading: isLoading,
      },
    }),
  [types.SET_INDUCTION_FORM_ITEM_CARLTON_FOREST_LOADING]: (state, isLoading) =>
    merge(state, {
      carltonForest: {
        ...state.carltonForest,
        isInductionFormItemLoading: isLoading,
      },
    }),
  [types.POST_SSOW_CARLTON_FOREST]: (state, { formName, formContent }) => {
    if (formName === "handBaller") {
      const previousSSOW =
        state.app.carltonForestOnboarding.SSOWHandBaller || [];
      return merge(state, {
        ...state,
        app: {
          ...state.app,
          carltonForestOnboarding: {
            ...state.app.carltonForestOnboarding,
            SSOWHandBaller: { ...previousSSOW, ...formContent },
          },
        },
      });
    }
    if (formName === "mhe") {
      const previousSSOW =
        state.app.carltonForestOnboarding.SSOWMaterialHandling || [];
      return merge(state, {
        ...state,
        app: {
          ...state.app,
          carltonForestOnboarding: {
            ...state.app.carltonForestOnboarding,
            SSOWMaterialHandling: { ...previousSSOW, ...formContent },
          },
        },
      });
    }
    return null;
  },
  [types.SET_SSOW_CARLTON_FOREST_LOADING]: (state, formName) =>
    merge(state, {
      carltonForest: { ...state.carltonForest, ssowFormName: formName },
    }),

  [types.SET_SSOW_ITEMS_CARLTON_FOREST_LOADING]: (state, isLoading) =>
    merge(state, {
      carltonForest: { ...state.carltonForest, isSSOWLoading: isLoading },
    }),

  [types.MARK_DOCUMENT_READ_CARLTON_FOREST]: (state, documentFilename) => {
    const carltonForestOnboardingState =
      state.app.carltonForestOnboarding || {};
    const currentDocs =
      (state.app.carltonForestOnboarding &&
        state.app.carltonForestOnboarding.readDocuments) ||
      [];

    return merge(state, {
      app: merge(state.app, {
        carltonForestOnboarding: {
          ...carltonForestOnboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },

  [types.SET_CARLTON_FOREST_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      carltonForestReading: { ...state.carltonForestReading, isLoading },
    }),

  [types.SET_INDUCTION_FORM_CARLTON_FOREST_LOADING]: (state, isLoading) =>
    merge(state, {
      carltonForestInductionForm: {
        ...state.carltonForestInductionForm,
        isLoading,
      },
    }),
  [types.SET_INDUCTION_FORM_ITEM_CARLTON_FOREST_LOADING]: (state, isLoading) =>
    merge(state, {
      carltonForestInductionFormItem: {
        ...state.carltonForestInductionFormItem,
        isLoading,
      },
    }),
  [types.POST_SSOW_CARLTON_FOREST]: (state, { formName, formContent }) => {
    if (formName === "handBaller") {
      const previousSSOW =
        state.app.carltonForestOnboarding.SSOWHandBaller || [];
      return merge(state, {
        ...state,
        app: {
          ...state.app,
          carltonForestOnboarding: {
            ...state.app.carltonForestOnboarding,
            SSOWHandBaller: { ...previousSSOW, ...formContent },
          },
        },
      });
    }
    if (formName === "mhe") {
      const previousSSOW =
        state.app.carltonForestOnboarding.SSOWMaterialHandling || [];
      return merge(state, {
        ...state,
        app: {
          ...state.app,
          carltonForestOnboarding: {
            ...state.app.carltonForestOnboarding,
            SSOWMaterialHandling: { ...previousSSOW, ...formContent },
          },
        },
      });
    }
    return null;
  },
  [types.SET_SSOW_CARLTON_FOREST_LOADING]: (state, formName) =>
    merge(state, {
      carltonForestSSOW: { ...state.carltonForestSSOW, formName },
    }),

  [types.SET_SOP_LOADING]: (state, formName) =>
    merge(state, {
      kingspanSOP: { ...state.kingspanSOP, formName },
    }),

  [types.SET_CONTINUING_REGISTRATION]: (state, isRegistering) => {
    return merge(state, {
      isRetryingRegister: isRegistering,
    });
  },
  [types.MARK_DOCUMENT_READ_GB]: (state, documentFilename) => {
    const greatBearState = state.app.greatBear || {};
    const currentDocs =
      (state.app.greatBear && state.app.greatBear.readDocuments) || [];

    return merge(state, {
      app: merge(state.app, {
        greatBear: {
          ...greatBearState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.SET_DOWNLOADING_REFLEX_ALLEN_FORMS]: (
    state,
    { formCode, isDownloading }
  ) => {
    const existingForm = state.reflexAllenForms.filter(
      (formElem) => formElem.formCode === formCode
    )[0];
    return existingForm
      ? merge(state, {
          reflexAllenForms: [
            ...state.reflexAllenForms.filter(
              (form) => form.formCode !== existingForm.formCode
            ),
            { formCode, isDownloading, pdfString: existingForm.pdfString },
          ],
        })
      : merge(state, {
          reflexAllenForms: [
            ...state.reflexAllenForms,
            { formCode, isDownloading },
          ],
        });
  },
  [types.GREAT_BEAR_READING_SET_IS_LOADING]: (state, isLoading) =>
    merge(state, {
      greatBearReading: { ...state.greatBearReading, isLoading },
    }),
  [types.POST_REFLEX_ALLEN_INDUCTION_PROGRAMME]: (state, content) => {
    const itemValues = Object.values(content.items);
    const itemsParsed = Object.keys(content.items).map((itemKey, i) => {
      return {
        key: itemKey,
        val: itemValues[i],
      };
    });
    const trueItems = itemsParsed
      .filter((item) => item.val === true)
      .map((item) => item.key);
    const falseItems = itemsParsed
      .filter((item) => item.val === false)
      .map((item) => item.key);
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        reflexAllen: {
          ...state.app.reflexAllen,
          inductionForm: {
            checkedItems: trueItems,
            uncheckedItems: falseItems,
          },
        },
      },
    });
  },
  [types.RTW_VERIFICATION_QUEUE_IS_LOADING]: (state, isLoading) =>
    merge(state, {
      rtwVerificationCall: { ...state.rtwVerificationCall, isLoading },
    }),
  [types.RTW_VERIFICATION_QUEUE_SIZE_SUCCESS]: (state, queueSize) => {
    return merge(state, {
      rtwVerificationCall: { ...state.rtwVerificationCall, queueSize },
    });
  },
  [types.RTW_VERIFICATION_QUEUE_DETAILS]: (state, rtwCallDetails) =>
    merge(state, {
      rtwVerificationCall: { ...state.rtwVerificationCall, ...rtwCallDetails },
    }),
  [types.RTW_VERIFICATION_FINISHED]: (state) =>
    merge(state, {
      rtwVerificationCall: {
        ...state.rtwVerificationCall,
        verificationFinished: true,
      },
    }),
  [types.CV_PROGRESS]: (state, progress) => {
    return merge(state, { app: { ...state.app, uploadProgress: progress } });
  },
  [types.POST_ROYAL_MAIL_FORM]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        royalMailOnboarding: {
          ...state.app.royalMailOnboarding,
          [formName]: formContent,
        },
      },
    });
  },
  [types.ROYAL_MAIL_ONBOARDING_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        royalMailOnboarding: {
          ...state.app.royalMailOnboarding,
          submitted: true,
        },
      },
    });
  },
  [types.POST_SOP_KINGSPAN]: (state, { formName, formContent }) => {
    if (formName === "line1") {
      const previousSOPS = state.app.kingspanOnboarding.SOPDocsLine1 || [];
      return merge(state, {
        ...state,
        app: {
          ...state.app,
          kingspanOnboarding: {
            ...state.app.kingspanOnboarding,
            SOPDocsLine1: { ...previousSOPS, ...formContent },
          },
        },
      });
    }
    if (formName === "line24") {
      const previousSOPS = state.app.kingspanOnboarding.SOPDocsLine24 || [];
      return merge(state, {
        ...state,
        app: {
          ...state.app,
          kingspanOnboarding: {
            ...state.app.kingspanOnboarding,
            SOPDocsLine24: { ...previousSOPS, ...formContent },
          },
        },
      });
    }
    if (formName === "line3") {
      const previousSOPS = state.app.kingspanOnboarding.SOPDocsLine3 || [];
      return merge(state, {
        ...state,
        app: {
          ...state.app,
          kingspanOnboarding: {
            ...state.app.kingspanOnboarding,
            SOPDocsLine3: { ...previousSOPS, ...formContent },
          },
        },
      });
    }
    if (formName === "shop1") {
      const previousSOPS = state.app.kingspanOnboarding.SOPDocsShop1 || [];
      return merge(state, {
        ...state,
        app: {
          ...state.app,
          kingspanOnboarding: {
            ...state.app.kingspanOnboarding,
            SOPDocsShop1: { ...previousSOPS, ...formContent },
          },
        },
      });
    }
    if (formName === "line3") {
      const previousSOPS = state.app.kingspanOnboarding.SOPDocsLine3 || [];
      return merge(state, {
        ...state,
        app: {
          ...state.app,
          kingspanOnboarding: {
            ...state.app.kingspanOnboarding,
            SOPDocsLine3: { ...previousSOPS, ...formContent },
          },
        },
      });
    }
    if (formName === "shop1") {
      const previousSOPS = state.app.kingspanOnboarding.SOPDocsShop1 || [];
      return merge(state, {
        ...state,
        app: {
          ...state.app,
          kingspanOnboarding: {
            ...state.app.kingspanOnboarding,
            SOPDocsShop1: { ...previousSOPS, ...formContent },
          },
        },
      });
    }
    return null;
  },
  [types.POST_GATE_FORM]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        gateOnboarding: {
          ...state.app.gateOnboarding,
          [formName]: formContent,
        },
      },
    });
  },
  [types.GATE_ONBOARDING_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        gateOnboarding: {
          ...state.app.gateOnboarding,
          submitted: true,
        },
      },
    });
  },
  [types.POST_DNATA_FORM]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        dnataOnboarding: {
          ...state.app.dnataOnboarding,
          [formName]: formContent,
        },
      },
    });
  },
  [types.SUBMIT_DNATA_EXTRA_FORM]: (state, { formName }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        dnataOnboarding: {
          ...state.app.dnataOnboarding,
          [formName]: true,
        },
      },
    });
  },
  [types.SET_DNATA_EXTRA_FORM_LOADING]: (state, formName) =>
    merge(state, {
      dnata: {
        ...state.dnata,
        formLoading: formName,
      },
    }),
  [types.UPLOAD_DNATA_PDF]: (state, fileKey) =>
    merge(state, {
      dnata: {
        ...state.dnata,
        [fileKey]: true,
      },
    }),
  [types.POST_NHS_REFERENCES_FORM]: (state, { formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        nhsReferenceForm: formContent.nhsReferences,
      },
    });
  },
  [types.SUBMIT_UMBRELLA_DECLARATION_FORM]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        umbrellaDeclarationForm: {
          completed: true,
        },
      },
    });
  },
  [types.POST_SWISSPORT_FORM]: (state, { formName }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        swissportOnboarding: {
          ...state.app.swissportOnboarding,
          [formName]: true,
        },
      },
    });
  },
  [types.POST_PECAN_FORMS]: (state, { formName, formContent }) => {
    const previousForms = state.app.pecanOnboarding.forms
      ? state.app.pecanOnboarding.forms
      : {};
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        pecanOnboarding: {
          ...state.app.pecanOnboarding,
          forms: { ...previousForms, [formName]: formContent },
        },
      },
    });
  },
  [types.POST_PUSTERLA_FORMS]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        pusterlaOnboarding: {
          ...state.app.pusterlaOnboarding,
          [formName]: formContent,
        },
      },
    });
  },
  [types.POST_PUSTERLA_ASSESSMENT_SCORE]: (state, { data }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        pusterlaOnboarding: {
          ...state.app.pusterlaOnboarding,
          score: data,
        },
      },
    });
  },
  [types.SUBMIT_PUSTERLA_FORMS]: (state, { typeCode, retryCounter }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        pusterlaOnboarding: {
          ...state.app.pusterlaOnboarding,
          [typeCode]: true,
          retryCounter,
        },
      },
    });
  },
  [types.SUBMIT_GLAA_FORMS]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        glaaOnboarding: {
          ...state.app.glaaOnboarding,
          YS01: true,
        },
      },
    });
  },
  [types.SUBMIT_PECAN_FORMS_SUCCESS]: (state) => {
    const previousForms = state.app.pecanOnboarding.forms;
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        pecanOnboarding: {
          ...state.app.pecanOnboarding,
          forms: { ...previousForms, submittedInduction: true },
        },
      },
    });
  },
  [types.SUBMIT_PECAN_ASSESSMENT_SUCCESS]: (state, payload) => {
    const previousForms = state.app.pecanOnboarding.forms;
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        pecanOnboarding: {
          ...state.app.pecanOnboarding,
          forms: {
            ...previousForms,
            submittedAssessment: true,
            assessment: { total: payload.total },
          },
        },
      },
    });
  },
  [types.DNATA_ONBOARDING_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        dnataOnboarding: {
          ...state.app.dnataOnboarding,
          submitted: true,
        },
      },
    });
  },
  [types.DNATA_TEST_SUBMITTED]: (state, payload) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        dnataOnboarding: {
          ...state.app.dnataOnboarding,
          test: {
            dnataTest: { ...payload },
          },
          testCompleted: true,
        },
      },
    });
  },
  [types.DNATA_TEST_IS_LOADING]: (state, isLoading) =>
    merge(state, {
      dnataTest: { ...state.dnataTest, isLoading },
    }),
  [types.SWISSPORT_IS_LOADING]: (state, isLoading) =>
    merge(state, {
      swissport: { ...state.swissport, isLoading },
    }),
  [types.PECAN_ASSESSMENT_IS_LOADING]: (state, isLoading) =>
    merge(state, {
      pecanAssessment: { ...state.pecanAssessment, isLoading },
    }),

  [types.SET_PECAN_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      pecanReading: { ...state.pecanReading, isLoading },
    }),

  [types.FOOD_HANDLING_FORM_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        foodHandling: true,
      },
    });
  },

  [types.MANUAL_HANDLING_FORM_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        manualHandling: true,
      },
    });
  },
  [types.CASH_ALCOHOL_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        cashAlcohol: true,
      },
    });
  },
  [types.NIGHT_WORKER_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        nightWorkerHealth: true,
      },
    });
  },
  [types.AUTHORITY_FOR_PAYMENTS_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        authorityForPayments: true,
      },
    });
  },
  [types.UPDATE_DETAILS_STORE_DATE]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        updateDetailsDate: new Date(),
      },
    });
  },
  [types.NOTIFICATIONS_LOAD_SUCCESS]: (state, payload) => {
    return merge(state, {
      ...state,
      notifications: {
        ...state.notifications,
        list: payload,
      },
    });
  },
  [types.NOTIFICATIONS_LAST_READ_SUCCESS]: (state, timestamp) => {
    return merge(state, {
      ...state,
      notifications: {
        ...state.notifications,
        lastReadDate: new Date(timestamp),
      },
    });
  },
  [types.NOTIFICATIONS_READ_UPDATE_SUCCESS]: (state, date) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        notificationData: {
          ...state.app.notificationData,
          lastread: date,
        },
      },
    });
  },
  [types.TEST_3_MONTH_PROMPT]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        updateDetailsDate: new Date("2021-05-01T10:32:16.0821980+01:00"),
      },
    });
  },
  [types.ABM_ONBOARDING_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        abmOnboarding: {
          ...state.app.abmOnboarding,
          submitted: true,
        },
      },
    });
  },
  [types.POST_ABM_FORMS]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        abmOnboarding: {
          ...state.app.abmOnboarding,
          [formName]: formContent,
        },
      },
    });
  },
  [types.POST_REGATTA_FORMS]: (state, { formName, formContent }) => {
    if (formName === "ReturnToWork") {
      const { ReturnToWork } = state.app.regattaOnboarding;

      return merge(state, {
        ...state,
        app: {
          ...state.app,
          regattaOnboarding: {
            ...state.app.regattaOnboarding,
            ReturnToWork: {
              ...formContent,
              ...ReturnToWork,
            },
          },
        },
      });
    }
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        regattaOnboarding: {
          ...state.app.regattaOnboarding,
          [formName]: formContent,
        },
      },
    });
  },
  [types.SUBMIT_REGATTA_FORMS]: (state, { typeCode }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        regattaOnboarding: {
          ...state.app.regattaOnboarding,
          [typeCode]: true,
        },
      },
    });
  },
  [types.CONTRACT_FOR_SERVICES_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        contractForServicesHandling: true,
      },
    });
  },

  [types.NON_HGV_ASSESSMENT_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        nonHGVSubmitted: true,
      },
    });
  },
  [types.NON_HGV_ASSESSMENT_PASSED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        nonHGVPassed: true,
      },
    });
  },
  [types.DRIVER_ASSESSMENT_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        driverAssesmentSubmitted: true,
      },
    });
  },
  [types.DRIVER_ASSESSMENT_PASSED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        driverAssessmentPassed: true,
      },
    });
  },
  [types.POST_DRIVING_FORM]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        drivingOnboarding: {
          ...state.app.drivingOnboarding,
          [formName]: formContent,
        },
      },
    });
  },
  [types.DRIVING_ONBOARDING_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        drivingOnboarding: {
          ...state.app.drivingOnboarding,
          submitted: true,
        },
      },
    });
  },
  [types.BIG_5_PERSONALITY_TEST_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        big5PersonalityTestHandling: true,
      },
    });
  },
  [types.EXPOSURE_BASED_MEMORY_TEST_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        exposureBasedMemoryTestHandling: true,
      },
    });
  },
  [types.NONVERBAL_IMMEDIACY_TEST_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        nonverbalImmediacyTestHandling: true,
      },
    });
  },
  [types.DISC_ASSESSMENT_TEST_SUBMITTED]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        discAssessmentTestHandling: true,
      },
    });
  },
  [types.DISK_ASSESSMENT_TEST_LOADING]: (state, isLoading) => {
    return merge(state, {
      isDiskAssessmentTestLoading: isLoading,
    });
  },
  [types.YOTI_SET_URL]: (state, url) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        yotiIframeUrl: url,
      },
    });
  },
  [types.UPDATE_GENERAL_CONSENT]: (state) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        generalConsent: true,
      },
    });
  },
  [types.MARK_DOCUMENT_READ_MOLECULAR]: (state, documentFilename) => {
    const molecularOnboardingState = state.app.molecularOnboarding || {};
    const currentDocs =
      (state.app.molecularOnboarding &&
        state.app.molecularOnboarding.readDocuments) ||
      [];

    return merge(state, {
      app: merge(state.app, {
        molecularOnboarding: {
          ...molecularOnboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.POST_MOLECULAR_FORMS]: (state, { formName }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        molecularOnboarding: {
          ...state.app.molecularOnboarding,
          [formName]: true,
        },
      },
    });
  },
  [types.POST_WOODLAND_FORMS]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        woodlandGroupOnboarding: {
          ...state.app.woodlandGroupOnboarding,
          [formName]: formContent,
        },
      },
    });
  },
  [types.MOLECULAR_ASSESSMENT_SUBMITTED]: (state, payload) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        molecularOnboarding: {
          ...state.app.molecularOnboarding,
          literacyTestResults: payload,
          YML3: true,
        },
      },
    });
  },
  [types.MOLECULAR_ASSESSMENT_IS_LOADING]: (state, isLoading) =>
    merge(state, {
      molecularAssessment: { ...state.molecularAssessment, isLoading },
    }),
  [types.MARK_DOCUMENT_READ_COMPLEAT_FOOD]: (state, documentFilename) => {
    const onboardingState = state.app.compleatFoodOnboarding || {};
    const currentDocs =
      (state.app.compleatFoodOnboarding &&
        state.app.compleatFoodOnboarding.readDocuments) ||
      [];

    return merge(state, {
      app: merge(state.app, {
        compleatFoodOnboarding: {
          ...onboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.SET_COMPLEAT_FOOD_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      compleatFood: {
        ...state.compleatFood,
        isReadingLoading: isLoading,
      },
    }),
  [types.SET_COMPLEAT_FOOD_FORM_LOADING]: (state, formName) =>
    merge(state, {
      compleatFood: {
        ...state.compleatFood,
        formLoading: formName,
      },
    }),

  [types.POST_COMPLEAT_FOOD_FORM]: (state, { formName }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        compleatFoodOnboarding: {
          ...state.app.compleatFoodOnboarding,
          [formName]: true,
        },
      },
    });
  },
  [types.SET_HOLIDAY_REQUEST_FORM_LOADING]: (state, isLoading) =>
    merge(state, {
      holidayRequest: {
        ...state.holidayRequest,
        holidayRequestFormLoading: isLoading,
      },
    }),

  [types.SET_HOLIDAY_REQUEST_FORM_SUBMITTED]: (state, status) =>
    merge(state, {
      holidayRequest: {
        ...state.holidayRequest,
        holidayRequestFormSubmitted: status,
      },
    }),

  [types.MARK_DOCUMENT_READ_GROW_UP_FARMS]: (state, documentFilename) => {
    const onboardingState = state.app.growUpFarmsOnboarding || {};
    const currentDocs =
      (onboardingState && onboardingState.readDocuments) || [];

    return merge(state, {
      app: merge(state.app, {
        growUpFarmsOnboarding: {
          ...onboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.SET_GROW_UP_FARMS_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      growUpFarmsReading: {
        ...state.growUpFarmsReading,
        isLoading,
      },
    }),
  [types.SUBMIT_GROW_UP_FARMS_QUESTIONNAIRE]: (state, { typeCode }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        growUpFarmsOnboarding: {
          ...state.app.growUpFarmsOnboarding,
          [typeCode]: true,
        },
      },
    });
  },
  [types.SET_GROW_UP_FARMS_FOOD_QUESTIONNAIRE_LOADING]: (state, isLoading) =>
    merge(state, {
      growUpFarmsFoodQuestionnaire: {
        ...state.growUpFarmsFoodQuestionnaire,
        isLoading,
      },
    }),
  [types.SET_GROW_UP_FARMS_FOOD_QUESTIONNAIRE_RESULTS]: (state, payload) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        growUpFarmsOnboarding: {
          ...state.app.growUpFarmsOnboarding,
          foodSafetyQuestionnaireResults: payload,
          YGUF: true,
        },
      },
    });
  },

  [types.MARK_DOCUMENT_READ_DAVIN_FOODS]: (state, documentFilename) => {
    const onboardingState = state.app.davinFoodsOnboarding || {};
    const currentDocs =
      (onboardingState && onboardingState.readDocuments) || [];

    return merge(state, {
      app: merge(state.app, {
        davinFoodsOnboarding: {
          ...onboardingState,
          readDocuments: [...currentDocs, documentFilename],
        },
      }),
    });
  },
  [types.SET_DAVIN_FOODS_READING_LOADING]: (state, isLoading) =>
    merge(state, {
      davinFoods: { ...state.davinFoods, isReadingLoading: isLoading },
    }),
  [types.SET_DAVIN_FOODS_QUIZ_LOADING]: (state, quizName) =>
    merge(state, {
      davinFoods: { ...state.davinFoods, quizLoading: quizName },
    }),
  [types.SET_DAVIN_FOODS_QUIZ_RESULTS]: (state, payload) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        davinFoodsOnboarding: {
          ...state.app.davinFoodsOnboarding,
          ...payload,
        },
      },
    });
  },
  [types.POST_DAVIN_FOODS_FORM]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        davinFoodsOnboarding: {
          ...state.app.davinFoodsOnboarding,
          [formName]: formContent,
        },
      },
    });
  },
  [types.POST_IPN_FORM]: (state, { formName, formContent }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        ipnOnboarding: {
          ...state.app.ipnOnboarding,
          inductionSubmitted: true,
        },
      },
    });
  },
  [types.SUBMIT_DAVIN_FOODS_FORM]: (state, { typeCode }) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        davinFoodsOnboarding: {
          ...state.app.davinFoodsOnboarding,
          [typeCode]: true,
        },
      },
    });
  },
  [types.SET_DAVIN_FOODS_QUIZ_SHOW_RESULTS]: (state, formName) =>
    merge(state, {
      davinFoods: { ...state.davinFoods, quizShowResults: formName },
    }),
  [types.KINGSPAN_ASSESSMENT_IS_LOADING]: (state, isLoading) =>
    merge(state, {
      kingspanAssessment: { ...state.kingspanAssessment, isLoading },
    }),

  [types.KINGSPAN_ASSESSMENT_SUBMITTED]: (state, payload) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        kingspanOnboarding: {
          ...state.app.kingspanOnboarding,
          literacyTestResultsKingspan: payload,
          YKN1: true,
        },
      },
    });
  },
  [types.REGATTA_ASSESSMENT_IS_LOADING]: (state, isLoading) =>
    merge(state, {
      regattaAssessment: { ...state.regattaAssessment, isLoading },
    }),

  [types.REGATTA_ASSESSMENT_SUBMITTED]: (state, payload) => {
    return merge(state, {
      ...state,
      app: {
        ...state.app,
        regattaOnboarding: {
          ...state.app.regattaOnboarding,
          literacyTestResultsRegatta: payload,
          YRG4: true,
        },
      },
    });
  },
};

/**
 * This function  is to allow the above to work as a reducer rather than the ugly switch statement
 */
export default (state = initialState, action) => {
  const { type, payload } = action;
  const actionHandler = actionHandlers[type];

  if (actionHandler) {
    switch (type) {
      case types.HTTP_404_ERROR:
      case types.HTTP_500_ERROR:
      case types.HTTP_OTHER_ERROR:
        return actionHandler(state, action);
      default:
        return actionHandler(state, payload);
    }
  }

  return state;
};
